import { k } from "../kaplay";

import { addPlayButton } from "../gameobjects/button";

import { createDecor } from "../gameobjects/decor";

k.scene("menu", async () => {
  // Corners
  k.add([k.rect(10, 10), k.pos(0, 0)])
  k.add([k.rect(10, 10), k.pos(k.width() - 10, 0)])
  k.add([k.rect(10, 10), k.pos(0, k.height() - 10)])
  k.add([k.rect(10, 10), k.pos(k.width() - 10, k.height() - 10)])

  // Decor
  createDecor();

  // Trees
  k.add([k.sprite("trees"), k.pos(0, 0), k.stay(), k.layer("foreground")])

  const startButton = addPlayButton(k.center().add(0, 270), () => { k.go("game"); k.play("music", { loop: true, volume: 0.6 }) });

  k.add([
    k.text("GLADY", { align: "center", font: "happy-o", size: 180 }),
    k.pos(k.center().add(0, -320)),
    k.anchor("center")
  ])

  k.add([
    k.sprite("player"),
    k.anchor("center"),
    k.pos(k.center().add(-220, -150)),
    k.scale(3.2)
  ])
  k.add([
    k.sprite("zombie"),
    k.anchor("center"),
    k.pos(k.center().add(215, -120)),
    k.scale(4)
  ])
  k.add([
    k.sprite("sword"),
    k.anchor("center"),
    k.pos(k.center().add(30, -150)),
    k.scale(4.5),
    k.rotate(60)
  ])

  k.add([
    k.text("SURVIVOR", { align: "center", font: "happy-o", size: 107 }),
    k.pos(k.center().add(0, 20)),
    k.anchor("center"),
    k.color(255, 0, 0)
  ])
})